import {
    collection,
    doc,
    getDoc,
    getDocs,
    increment,
    query,
    setDoc,
    updateDoc,
    where,
    writeBatch,
} from "firebase/firestore";
import Papa from "papaparse";
import {getDb} from "./Constants";
import Swal from "sweetalert2";
import moment from "moment/moment";

export const getUsersEmail = async (data, eventId, db) => {
    let emails = [];
    const emailsData = data.map((e, index) => e.email).filter((e) => e);

    const citiesRef = collection(db, "users");

    // batch size of 10
    const batchSize = 10;
    for (let i = 0; i < emailsData.length; i += batchSize) {
        const batch = emailsData.slice(i, i + batchSize);
        const q = query(
            citiesRef,
            where("email", "in", batch),
            where("eventId", "==", eventId)
        );
        const querySnapshot = await getDocs(q);
        const documents = querySnapshot.docs;

        if (documents) {
            documents.forEach((doc) => {
                const data = doc.data();
                emails.push(data.email);
            });
        }
    }
    return emails;
};
export const fileUpload = async (
    file,
    maxUsers,
    uid,
    usersCount,
    eventId,
    db,
    gameLink = "",
    signedInUser
) => {
    const processedEmails = [];
    let count = usersCount;

    try {
        const results = await new Promise((resolve, reject) => {
            Papa.parse(file, {
                header: true,
                complete: (results) => resolve(results),
                error: (error) => reject(error),
            });
        });

        if (
            usersCount < maxUsers &&
            results.data.length - 1 + usersCount <= maxUsers
        ) {
            const userId = uid;
            const emailsData = await getUsersEmail(results.data, eventId, db);
            const batch = writeBatch(db);

            for (let i = 0; i < results.data.length; i++) {
                const userData = results.data[i];
                if (userData.email && !emailsData.includes(userData.email)) {
                    const usersRef = doc(db, "users", userData.email + eventId);
                    const userDataObj = {
                        eventId: eventId,
                        achievementCount: 0,
                        achievements: {
                            highAchiever: 0,
                            mostlyRight: 0,
                            speedDemon: 0,
                            streakOf10: 0,
                        },
                        attempts: 1,
                        avatar: -1,
                        capabilities: {}, // populate
                        completed: false,
                        completedOnce: false,
                        currentLevel: 1,
                        currentScore: 0,
                        cognitiveScore: 0,
                        aptitudeScore: 0,
                        behaviourScore: 0,
                        department:
                            signedInUser?.projectType === "progress" && userData.department
                                ? userData.department
                                : "",
                        email: userData.email,
                        email_insensitive: userData.email.toLowerCase(),
                        isActive: true,
                        canExpire: false,
                        lastCompletedScore: 0,
                        lastUpdated: Date.now(),
                        levelScores: {},
                        levels: {},
                        name: userData.email.split("@")[0].toLowerCase(),
                        name_insensitive: userData.email.split("@")[0].toLowerCase(),
                        region:
                            signedInUser?.projectType === "progress" && userData.region ? userData.region : "",
                        userCreated: Date.now(),
                        expiryDate: "",
                    };

                    await setDoc(usersRef, userDataObj);

                    // await sendInviteEmail(userData.email, gameLink); // sending invite email

                    if (!processedEmails.includes(userData.email)) {
                        count++;
                        processedEmails.push(userData.email);
                        await updateDoc(doc(db, "users", "analytics"), {
                            [eventId]: increment(1),
                        });
                        await updateDoc(doc(getDb(), "admins", userId), {
                            usersCount: increment(1),
                        });
                    }
                }
            }
            Swal.fire({
                icon: "success",
                title: "Invitation Sent!",
                text: "Invitations have been sent.",
            });

            return count;
        } else {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "You have reached your maximum user limit. Please upgrade your plan to add more users.",
            });
        }
    } catch (error) {
        console.error("Error adding document: ", error);
    }

    return count;
};

export const sendInviteEmail = async (email, eventId) => {
    try {
        console.log("send email", email);
        // const docRef = doc(getDb(), "Events", eventId);
        // const docSnap = await getDoc(docRef);
        // let eventData = {};
        // if (docSnap.exists()) {
        //     eventData = docSnap.data();
        // }
        // let data = JSON.stringify({
        //     from: "",
        //     to: email,
        //     gameLink: eventData.gameLink,
        //     subject: "ACE Game Invitation",
        //     eventName: eventData?.assessmentName,
        //     eventFor: eventData?.assessmentFor,
        // });
        // let config = {
        //     method: "post",
        //     maxBodyLength: Infinity,
        //     url: "https://lklfwc5una.execute-api.us-east-1.amazonaws.com/dev/sendInvite",
        //     headers: {
        //         "Content-Type": "application/json",
        //     },
        //     data: data,
        // };
        // console.log(config, "config");
        // axios
        //     .request(config)
        //     .then((response) => {
        //         console.log(JSON.stringify(response.data));
        //     })
        //     .catch((error) => {
        //         console.log(error);
        //     });
    } catch (e) {
        console.log(e);
    }
};

export const addUserInGame = async (userData, eventId) => {
    // const userId = signedInUser.uid;
    const event = await getSignedInUserByEvent(eventId);
    const userId = event.userId;
    const userDocId = userData.email.toLowerCase().trim() + eventId;
    const userRef = doc(getDb(), "users", userDocId);
    const userSnap = await getDoc(userRef);
    if (userSnap.exists()) {
        await updateDoc(userRef, {userInfo: {...userData, companyId: eventId, lastUpdated: Date.now()}});
    } else {
        await setDoc(userRef, {
            userInfo: {...userData, companyId: eventId, createdAt: moment().unix()},
            eventId: eventId,
            achievementCount: 0,
            achievements: {
                highAchiever: 0,
                mostlyRight: 0,
                speedDemon: 0,
                streakOf10: 0,
            },
            attempts: 1,
            avatar: -1,
            capabilities: {}, // populate
            completed: false,
            completedOnce: false,
            currentLevel: 1,
            currentScore: 0,
            cognitiveScore: 0,
            aptitudeScore: 0,
            behaviourScore: 0,
            department: "",
            region: "",
            email: userData.email,
            email_insensitive: userData.email.toLowerCase(),
            isActive: true,
            canExpire: false,
            lastCompletedScore: 0,
            lastUpdated: Date.now(),
            levelScores: {},
            levels: {},
            name: userData.name,
            name_insensitive: userData.name.toLowerCase(),
            userCreated: Date.now(),
            expiryDate: null,
        });
        await updateDoc(doc(getDb(), "users", "analytics"), {
            [eventId]: increment(1),
        });
        await updateDoc(doc(getDb(), "admins", userId), {
            usersCount: increment(1),
        });
    }
}

const getSignedInUserByEvent = async (eventId) => {
    const eventRef = doc(getDb(), "Events", eventId);
    const eventSnap = await getDoc(eventRef);
    if (eventSnap.exists()) {
        return eventSnap.data();
    }
}
